import type { ReactNode } from "react";

/**
 * Liste | Detail nebeneinander (M-008 D4, Design-Guide `detail-formen.md`): für Listen, die man der Reihe nach abarbeitet
 * (Meine Aufgaben, Abnahmen). Nur ab `lg` stehen beide Spalten da (Liste 2/5, Detail 3/5, das Detail klebt unter der Kopfzeile);
 * darunter gibt es nur die Liste, das Tippen auf eine Zeile öffnet die eigene Seite (D3) bzw. das Fachmodul. Der Baustein
 * prüft keine Rechte und lädt nichts: Liste und Detail kommen fertig vom Aufrufer, das Detail erst nach dessen Leseprüfung.
 */
export function ListeDetail({
  liste,
  detail,
  listeName,
  detailName,
}: {
  liste: ReactNode;
  detail: ReactNode;
  /** Zugänglicher Name des Listenbereichs. */
  listeName: string;
  /** Zugänglicher Name des Detailbereichs. */
  detailName: string;
}) {
  return (
    <>
      {/* Preline: productivity/work-management/projects.html#project-details (Anordnung Liste | Detail, M-008 D4) */}
      <div className="lg:grid lg:grid-cols-5 lg:items-start lg:gap-5" data-liste-detail="">
        <section aria-label={listeName} className="min-w-0 space-y-5 lg:col-span-2">
          {liste}
        </section>
        <aside
          aria-label={detailName}
          className="hidden min-w-0 lg:col-span-3 lg:block lg:sticky lg:top-29 lg:max-h-[calc(100dvh-7.25rem)] lg:overflow-y-auto group-data-[zeile2=zu]/shell:lg:top-14 group-data-[zeile2=zu]/shell:lg:max-h-[calc(100dvh-3.5rem)]"
        >
          {detail}
        </aside>
      </div>
    </>
  );
}
